import { render, staticRenderFns } from "./wxeEmpower.vue?vue&type=template&id=5e732a43&scoped=true"
import script from "./wxeEmpower.vue?vue&type=script&lang=js"
export * from "./wxeEmpower.vue?vue&type=script&lang=js"
import style0 from "./wxeEmpower.vue?vue&type=style&index=0&id=5e732a43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_v5mjhuasro5cnca5bddsdhezz4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e732a43",
  null
  
)

export default component.exports